import { render, staticRenderFns } from "./order2.vue?vue&type=template&id=14279a8d&scoped=true"
import script from "./order2.vue?vue&type=script&lang=js"
export * from "./order2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14279a8d",
  null
  
)

export default component.exports